export * from './licenses-buy-product.component';
